export function HelpPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Help</h1>
          <p className="page-subtitle">MVP の対応範囲と出力形式です。</p>
        </div>
      </header>

      <section className="grid two">
        <div className="surface" style={{ padding: 18 }}>
          <h2 className="section-title">対応 JSON</h2>
          <p className="section-note">
            timelineObjects、semanticSegments、rawSignals、locations、placeVisit、activitySegment を含む Google Timeline 系 JSON を判定します。
          </p>
        </div>
        <div className="surface" style={{ padding: 18 }}>
          <h2 className="section-title">未対応</h2>
          <p className="section-note">外部 Places API、写真連携、交通費自動計算、クラウド LLM 解析、共有 URL は MVP では実装していません。</p>
        </div>
      </section>
    </div>
  );
}
